import { once } from "es-toolkit/compat";
import { useRef } from "react";
import { sendUsage } from "utils/freemium";

export type UseMusicResult = {
  // Fires `sendUsage("sleepMusic")` exactly once per VM lifetime — wired to
  // the audio element's `onPlay`. Stubbable via `di={{ useVm }}` so storybook
  // doesn't POST `/api/beyond/usage` on every render.
  onAudioPlay: () => void;
};

export function useMusic(): UseMusicResult {
  const ref = useRef<UseMusicResult>();
  if (!ref.current) {
    ref.current = { onAudioPlay: once(() => sendUsage("sleepMusic")) };
  }
  return ref.current;
}
